/**
 * Wicked Web theme JavaScript
 */
(function () {
  'use strict';

  /* Mobile menu */
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const menuClose = document.querySelector('[data-menu-close]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  const menuOverlay = document.querySelector('[data-menu-overlay]');

  function openMenu() {
    mobileNav?.removeAttribute('hidden');
    menuOverlay?.removeAttribute('hidden');
    requestAnimationFrame(() => {
      mobileNav?.classList.add('is-open');
      menuOverlay?.classList.add('is-open');
    });
    menuToggle?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('no-scroll');
  }

  function closeMenu() {
    mobileNav?.classList.remove('is-open');
    menuOverlay?.classList.remove('is-open');
    menuToggle?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('no-scroll');
    setTimeout(() => {
      mobileNav?.setAttribute('hidden', '');
      menuOverlay?.setAttribute('hidden', '');
    }, 400);
  }

  menuToggle?.addEventListener('click', openMenu);
  menuClose?.addEventListener('click', closeMenu);
  menuOverlay?.addEventListener('click', closeMenu);

  /* Cart drawer */
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartToggles = document.querySelectorAll('[data-cart-toggle]');
  const cartCloses = document.querySelectorAll('[data-cart-close]');

  function openCart() {
    cartDrawer?.removeAttribute('hidden');
    cartDrawer?.removeAttribute('aria-hidden');
    requestAnimationFrame(() => cartDrawer?.classList.add('is-open'));
    document.body.classList.add('no-scroll');
  }

  function closeCart() {
    cartDrawer?.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    setTimeout(() => {
      cartDrawer?.setAttribute('hidden', '');
      cartDrawer?.setAttribute('aria-hidden', 'true');
    }, 400);
  }

  cartToggles.forEach((btn) => btn.addEventListener('click', openCart));
  cartCloses.forEach((btn) => btn.addEventListener('click', closeCart));

  const settings = window.themeSettings || {};

  /* Falling logos - 3 depth layers: far (small, blurred, slow), mid, near (large, sharp, quicker) */
  function initFallingLogos() {
    const container = document.querySelector('[data-falling-logos]');
    if (!container || container.dataset.ready === 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const url = container.dataset.logoUrl;
    if (!url) return;

    const isMobile = window.innerWidth < 768;
    const layers = [
      { count: isMobile ? 5 : 8, size: [1.1, 1.9], blur: 2, peak: [0.07, 0.11], duration: [26, 36] },
      { count: isMobile ? 4 : 7, size: [2.0, 3.0], blur: 0.75, peak: [0.1, 0.16], duration: [18, 26] },
      { count: isMobile ? 3 : 5, size: [3.2, 4.4], blur: 0, peak: [0.14, 0.2], duration: [13, 18] },
    ];

    const rand = (min, max) => min + Math.random() * (max - min);
    const fragment = document.createDocumentFragment();

    layers.forEach((layer) => {
      for (let i = 0; i < layer.count; i++) {
        const img = document.createElement('img');
        img.src = url;
        img.alt = '';
        img.className = 'falling-logos__item';
        img.decoding = 'async';
        img.style.setProperty('--left', `${rand(3, 94).toFixed(1)}%`);
        img.style.setProperty('--delay', `${rand(0, 18).toFixed(1)}s`);
        img.style.setProperty('--duration', `${rand(layer.duration[0], layer.duration[1]).toFixed(1)}s`);
        img.style.setProperty('--size', `${rand(layer.size[0], layer.size[1]).toFixed(2)}rem`);
        img.style.setProperty('--blur', `${layer.blur}px`);
        img.style.setProperty('--drift', `${rand(-3.5, 3.5).toFixed(1)}rem`);
        img.style.setProperty('--peak', rand(layer.peak[0], layer.peak[1]).toFixed(2));
        img.style.setProperty('--sway', `${rand(10, 26).toFixed(0)}deg`);
        fragment.appendChild(img);
      }
    });

    container.appendChild(fragment);
    container.dataset.ready = 'true';
  }

  initFallingLogos();

  /* Product grid stagger reveal */
  const gridItems = document.querySelectorAll('.product-grid__item');
  if (gridItems.length && 'IntersectionObserver' in window) {
    const gridObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const el = entry.target;
            const idx = Number(el.dataset.index || 0);
            el.style.transitionDelay = `${idx * 60}ms`;
            el.classList.add('is-visible');
            gridObserver.unobserve(el);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -20px 0px' }
    );
    gridItems.forEach((el, i) => {
      el.dataset.index = String(i);
      gridObserver.observe(el);
    });
  } else {
    gridItems.forEach((el) => el.classList.add('is-visible'));
  }

  /* Header scroll shrink */
  const header = document.querySelector('[data-header]');

  if (header && settings.scrollShrink !== false) {
    const onScroll = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 48);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Logo entry animation */
  function playLogoEntry() {
    if (settings.logoEntry === false) return;
    document.querySelector('.site-header__logo-img')?.classList.add('logo-enter');
  }

  /* Loading screen - once per session on homepage */
  const loadingScreen = document.querySelector('[data-loading-screen]');

  if (loadingScreen && settings.loadingScreen !== false && !sessionStorage.getItem('ww-loaded')) {
    document.body.classList.add('is-loading');
    const finish = () => {
      loadingScreen.classList.add('is-done');
      sessionStorage.setItem('ww-loaded', '1');
      setTimeout(() => {
        loadingScreen.remove();
        document.body.classList.remove('is-loading');
        playLogoEntry();
      }, 550);
    };
    setTimeout(finish, 1600);
  } else {
    if (loadingScreen) loadingScreen.remove();
    playLogoEntry();
  }

  /* Scroll reveal - legacy sections */
  const revealElements = document.querySelectorAll('[data-reveal]');
  if (revealElements.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    revealElements.forEach((el) => observer.observe(el));
  } else {
    revealElements.forEach((el) => el.classList.add('is-visible'));
  }

  /* Media gallery */
  document.querySelectorAll('[data-media-gallery]').forEach((gallery) => {
    const slides = gallery.querySelectorAll('[data-media-slide]');
    const thumbs = gallery.querySelectorAll('[data-thumb-trigger]');

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const id = thumb.dataset.mediaId;
        slides.forEach((slide) => {
          slide.classList.toggle('is-active', slide.dataset.mediaId === id);
        });
        thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
      });
    });
  });

  /* Product variant picker */
  const productSection = document.querySelector('[data-product-section]');
  if (productSection) {
    const productJson = productSection.querySelector('[data-product-json]');
    if (productJson) {
      const product = JSON.parse(productJson.textContent);
      const variantInput = productSection.querySelector('[data-variant-id]');
      const addButton = productSection.querySelector('[data-add-to-cart]');
      const priceEl = productSection.querySelector('[data-price]');
      const optionInputs = productSection.querySelectorAll('[data-option-input]');

      function getSelectedOptions() {
        const options = [];
        product.options.forEach((_, index) => {
          const checked = productSection.querySelector(
            `[data-option-position="${index + 1}"]:checked`
          );
          options.push(checked ? checked.value : null);
        });
        return options;
      }

      function findVariant() {
        const selected = getSelectedOptions();
        return product.variants.find((variant) =>
          variant.options.every((opt, i) => opt === selected[i])
        );
      }

      function updateVariantUI(variant) {
        if (!variant) return;
        if (variantInput) variantInput.value = variant.id;

        if (priceEl) {
          const compareAt = variant.compare_at_price;
          const price = variant.price;
          if (compareAt && compareAt > price) {
            priceEl.innerHTML = `<span class="price--compare">${formatMoney(compareAt)}</span><span class="price--sale">${formatMoney(price)}</span>`;
          } else {
            priceEl.innerHTML = `<span>${formatMoney(price)}</span>`;
          }
        }

        if (addButton) {
          const buyable = variant.available || variant.inventory_policy === 'continue';
          addButton.disabled = !buyable;
          addButton.textContent = buyable
            ? addButton.dataset.availableText || 'Add to cart'
            : 'Sold out';
          addButton.classList.toggle('btn--sold-out', !buyable);
        }
      }

      function formatMoney(cents) {
        return (cents / 100).toLocaleString(undefined, {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'USD',
        });
      }

      if (addButton) {
        addButton.dataset.availableText = addButton.textContent.trim();
      }

      optionInputs.forEach((input) => {
        input.addEventListener('change', () => {
          const variant = findVariant();
          if (variant) updateVariantUI(variant);
        });
      });
    }
  }

  /* AJAX add to cart */
  const productForm = document.querySelector('#product-form');
  productForm?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const formData = new FormData(productForm);
    const submitBtn = productForm.querySelector('[data-add-to-cart]');
    if (submitBtn) submitBtn.disabled = true;

    try {
      const response = await fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        body: formData,
      });
      if (!response.ok) throw new Error('Add to cart failed');
      const item = await response.json();
      updateCartCount(item.quantity || 1);
      openCart();
      await refreshCartDrawer();
    } catch (err) {
      console.error(err);
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  });

  function updateCartCount(qty) {
    const countEl = document.querySelector('[data-cart-count]');
    if (!countEl) return;
    const match = countEl.textContent.match(/\d+/);
    const current = match ? parseInt(match[0], 10) : 0;
    const next = current + qty;
    countEl.textContent = `(${next})`;
    countEl.hidden = next === 0;
    countEl.classList.add('is-pulse');
    setTimeout(() => countEl.classList.remove('is-pulse'), 450);
  }

  async function refreshCartDrawer() {
    try {
      const response = await fetch(window.routes.cart_url + '?section_id=cart-drawer');
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newBody = doc.querySelector('[data-cart-drawer-body]');
      const currentBody = document.querySelector('[data-cart-drawer-body]');
      if (newBody && currentBody) {
        currentBody.innerHTML = newBody.innerHTML;
      }
    } catch (err) {
      console.error(err);
    }
  }
})();
